import { render } from "./Modals.vue?vue&type=template&id=e5981876&scoped=true"
import script from "./Modals.vue?vue&type=script&lang=js"
export * from "./Modals.vue?vue&type=script&lang=js"

import "./Modals.vue?vue&type=style&index=0&id=e5981876&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5981876"]])

export default __exports__